import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Ledger/Ledgertable.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { useGetReportsLedgerQuery } from "../../slices/admin/admin";
import { useLocation, useNavigate } from "react-router-dom";
import PayableLedger from "./PayableLedger";
import NetProfit from "./NetProfit";
import { capitalize } from "../../utils/capitalize";

const Ledger = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [fromAmount, setFromAmount] = useState("");
  const [toAmount, setToAmount] = useState("");
  // const [activeTab, setActiveTab] = useState("receivable"); 

  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("activeTab") || location.state?.activeTab || "receivable";
  });

  // Sync activeTab state changes to the URL parameter
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("activeTab", activeTab);
    navigate(`?${searchParams.toString()}`, { replace: true, state: location.state });
  }, [activeTab, navigate, location.search, location.state]);

  const { data, isLoading, isError } = useGetReportsLedgerQuery({
    offset: currentPage,
    limit,
    search,
    minAmount: fromAmount,
    maxAmount: toAmount,
  });

  const clearFilters = () => {
    setSearch("");
    setFromAmount("");
    setToAmount("");
    setCurrentPage(1);
  };



  return (
    <div className={styles.ledgerContainer}>
      {/* --- Tabs --- */}
      <div className={styles.dflex}>
        <button
          className={`${styles.tab} ${activeTab === "receivable" ? styles.activeTab : ""
            }`}
          onClick={() => setActiveTab("receivable")}
        >
          Sales Ledger
        </button>
        <button
          className={`${styles.tab} ${activeTab === "payable" ? styles.activeTab : ""
            }`}
          onClick={() => setActiveTab("payable")}
        >
          Purchase Ledger
        </button>
        <button
          className={`${styles.tab} ${activeTab === "netProfit" ? styles.activeTab : ""
            }`}
          onClick={() => setActiveTab("netProfit")}
        >
          Net Profit
        </button>
      </div>

      {/* --- Receivable Ledger Table --- */}
      {activeTab === "receivable" && (
        <>
          {/* --- Filters --- */}
          <div className={styles.filterBar}>
            <input
              type="text"
              placeholder="Search..."
              className={styles.searchInput}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <input
              type="number"
              placeholder="From Amount"
              className={styles.searchInput}
              value={fromAmount}
              onChange={(e) => setFromAmount(e.target.value)}
            />
            <input
              type="number"
              placeholder="To Amount"
              className={styles.searchInput}
              value={toAmount}
              onChange={(e) => setToAmount(e.target.value)}
            />
            <button className={styles.clearBtn} onClick={clearFilters}>
              Clear All
            </button>
          </div>

          {/* --- Table --- */}
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Org Name</th>
                  <th>Phone</th>
                  <th>Pending Credit</th>
                  <th>Debit Balance</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="7" className={styles.noData}>
                      Loading...
                    </td>
                  </tr>
                ) : isError ? (
                  <tr>
                    <td colSpan="7" className={styles.noData}>
                      Error loading data
                    </td>
                  </tr>
                ) : data?.customers?.length > 0 ? (
                  data.customers.map((item) => (
                    <tr key={item._id}>
                      <td>{item.customer?.firstName ? capitalize(item.customer.firstName) : "-"}</td>
                      <td>{item.storeName ? capitalize(item.storeName) : "-"}</td>
                      <td className="notranslate">{item.customer?.phone || "-"}</td>
                      <td className="notranslate">
                        {item.totalCreditAmount > 0 ? (
                          <span className={`${styles.status} ${styles.statusPending}`}>
                            ₹ {item.totalCreditAmount}
                          </span>
                        ) : (
                          `₹ ${item.totalCreditAmount || 0}`
                        )}
                      </td>
                      <td className="notranslate">₹ {item.walletBalance || 0}</td>
                      <td>
                        <FaArrowRightToBracket
                          onClick={() =>
                            navigate(
                              `/dashboard/ViewLadger?id=${item._id}&mode=view`
                            )
                          }
                          className={styles.icon}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className={styles.noData}>
                      No journal entries found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil((data?.total || 0) / limit)}
              onPageChange={setCurrentPage}
            />
            <select
              className={styles.inputsbtn}
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10 rows</option>
              <option value={25}>25 rows</option>
              <option value={50}>50 rows</option>
            </select>
          </div>
        </>
      )}

      {/* --- Payable Ledger Table (Static Data) --- */}
      {activeTab === "payable" && (
        <PayableLedger />
      )}

      {/* --- Net Profit Table (Static Data) --- */}
      {activeTab === "netProfit" && (
        <NetProfit />
      )}
    </div>
  );
};

export default Ledger;


